import ProductCURModule from "@/modules/SiteProductCUR";

function SiteProductViewPage() {
  return <ProductCURModule type="view" />;
}

export default SiteProductViewPage;
